import {
    createBaseThemeOptions,
    createUnifiedTheme,
    genPageTheme,
    palettes,
    shapes,
} from '@backstage/theme';

import AvenirNextW04 from '../assets/fonts/AvenirNextW04-Regular.woff2';

const avenirNextRegular = {
    fontFamily: 'Avenir Next',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 300,
    src: `
      local('Avenir Next'),
      url(${AvenirNextW04}) format('woff2'),
    `,
};


// @deprecated Should be replaced with BUI as soon as available
export const douglasLight = createUnifiedTheme({
    ...createBaseThemeOptions({
        palette: {
            ...palettes.light,
            primary: {
                main: '#3cbeaf',
            },
            secondary: {
                main: '#3cbeaf',
            },
            error: {
                main: '#8c4351',
            },
            warning: {
                main: '#8f5e15',
            },
            info: {
                main: '#34548a',
            },
            success: {
                main: '#485e30',
            },
            background: {
                default: '#fff',
                paper: '#fff',
            },
            banner: {
                info: '#34548a',
                error: '#8c4351',
                text: '#343b58',
                link: '#565a6e',
            },
            errorBackground: '#8c4351',
            warningBackground: '#8f5e15',
            infoBackground: '#343b58',
            navigation: {
                background: '#c3eae4',
                navItem: {
                    hoverBackground: "#e6f6f4"
                },
                indicator: '#212121',
                color: '#212121',
                selectedColor: '#212121',
            },
        },
    }),
    defaultPageTheme: 'home',
    fontFamily: 'Avenir Next',
    /* Custom font added */
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                '@font-face': [avenirNextRegular],
            },
        },
    },
    /* below drives the header colors */
    pageTheme: {
        home: genPageTheme({ colors: ['#3cbeaf', '#9bdcd2'], shape: shapes.wave2 }),
        documentation: genPageTheme({
            colors: ['#8c4351', '#343b58'],
            shape: shapes.wave2,
        }),
        tool: genPageTheme({ colors: ['#8c4351', '#343b58'], shape: shapes.round }),
        service: genPageTheme({
            colors: ['#8c4351', '#343b58'],
            shape: shapes.wave,
        }),
        website: genPageTheme({
            colors: ['#8c4351', '#343b58'],
            shape: shapes.wave,
        }),
        library: genPageTheme({
            colors: ['#8c4351', '#343b58'],
            shape: shapes.wave,
        }),
        other: genPageTheme({ colors: ['#8c4351', '#343b58'], shape: shapes.wave }),
        app: genPageTheme({ colors: ['#8c4351', '#343b58'], shape: shapes.wave }),
        apis: genPageTheme({ colors: ['#8c4351', '#343b58'], shape: shapes.wave }),
    },
});

export const douglasDark = createUnifiedTheme({
    ...createBaseThemeOptions({
        palette: {
            ...palettes.dark,
            primary: {
                main: '#3cbeaf',
            },
            secondary: {
                main: '#3cbeaf',
            },
            error: {
                main: '#8c4351',
            },
            warning: {
                main: '#8f5e15',
            },
            info: {
                main: '#34548a',
            },
            success: {
                main: '#485e30',
            },
            background: {
                default: '#333',
                paper: '#444',
            },
            banner: {
                info: '#34548a',
                error: '#8c4351',
                text: '#343b58',
                link: '#565a6e',
            },
            errorBackground: '#8c4351',
            warningBackground: '#8f5e15',
            infoBackground: '#343b58',
            navigation: {
                background: '#444',
                navItem: {
                    hoverBackground: "#212121"
                },
                indicator: '#3cbeaf',
                color: '#3cbeaf',
                selectedColor: '#fff',
            },
        },
    }),
    defaultPageTheme: 'home',
    fontFamily: 'Avenir Next',
    /* Custom font added */
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                '@font-face': [avenirNextRegular],
            },
        },
    },
    /* below drives the header colors */
    pageTheme: {
        home: genPageTheme({ colors: ['#3cbeaf', '#9bdcd2'], shape: shapes.wave2 }),
        documentation: genPageTheme({
            colors: ['#8c4351', '#343b58'],
            shape: shapes.wave2,
        }),
        tool: genPageTheme({ colors: ['#3cbeaf', '#9bdcd2'], shape: shapes.round }),
        service: genPageTheme({
            colors: ['#3cbeaf', '#9bdcd2'],
            shape: shapes.wave,
        }),
        website: genPageTheme({
            colors: ['#3cbeaf', '#9bdcd2'],
            shape: shapes.wave,
        }),
        library: genPageTheme({
            colors: ['#3cbeaf', '#9bdcd2'],
            shape: shapes.wave,
        }),
        other: genPageTheme({ colors: ['#3cbeaf', '#9bdcd2'], shape: shapes.wave }),
        app: genPageTheme({ colors: ['#3cbeaf', '#9bdcd2'], shape: shapes.wave }),
        apis: genPageTheme({ colors: ['#3cbeaf', '#9bdcd2'], shape: shapes.wave }),
    },
});

